import axios from "axios";
import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import { axiosInstance } from "../useAxios/useAxios";
import { useApplicationContext } from "../../context/ApplicationContext";


export const getStoryList_API = async (body, handleSnackbar) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryList,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "login response");
    return response;
  } catch (error) {
    console.log(error, "login error");
    if (handleSnackbar) {
      handleSnackbar("Failed to load stories", "error");
    }
    return null; 
  }
};


export const getSingleStory_API = async (body, handleSnackbar) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userSingleStory,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "get single story response");
    return response;
  } catch (error) {
    console.log(error, "lget single storyr");
    if (handleSnackbar) {
      handleSnackbar("Failed to load single story", "error");
    }
    return null; 
  }
};

export const getStoryListAll_API = async (query) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryListAll + `?${query}`,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getStoryPropertiesList_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryPropertiesList,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getStoryProirityList_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryPriority,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getStoryStatusList_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryStatus,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getStoryTypeList_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryType,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getStoryMOSCOWList_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryMOSCOW,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getStoryConfidencialityList_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryConfidenciality,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const addStory_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStory,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const updateStory_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStory,
      method: "PUT",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const deleteStory_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStory,
      method: "DELETE",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const getUserStoryItemsForLink_API = async (query) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryLink + `?${query}`,
      method: "GET",
      // data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const generateUserStoryCustomId_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryCustomId,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const addCommentUserStory_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryComment,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};

export const updateCommentUserStory_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.userStoryComment,
      method: "PUT",
      data: body,
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log(response, "loginresponsne response");
    return response;
  } catch (error) {
    console.log(error, "loginresponsne error");
    return error;
  }
};
